import Vue from 'vue'
import VueRouter from 'vue-router'
import Students from '@/views/Students.vue'
import ThankYou from '@/views/ThankYou.vue'
import ThankYouPrivateTrustPilot from '@/views/ThankYouPrivateTrustPilot.vue'
import Nerds from '@/views/Nerds.vue'
import How from '@/views/How.vue'
import PrivateTrustpilot from '@/views/PrivateTrustpilot.vue'
// import VueCarousel from 'vue-carousel'
// import Pricing from '@/views/Pricing.vue'
// import Pay from '@/views/Pay.vue'

Vue.use(VueRouter)
// Vue.use(VueCarousel)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home3.vue')
  },
  {
    path: '/white-home',
    name: 'White Home',
    component: () => import('../views/WhiteHome.vue')
  },
  // We need these pages to be loaded quickly
  {
    path: '/for-students',
    name: 'For Students',
    component: Students
  },
  {
    path: '/for-nerds',
    name: 'For Nerds',
    component: Nerds
  },
  {
    path: '/how-it-works',
    name: 'How',
    component: How
  },
  {
    path: '/pricing',
    name: 'Pricing',
    redirect: '/'
    // component: Pricing
  },
  {
    path: '/pay',
    name: 'Pay',
    redirect: '/'
    // props: route => ({
    //   task: route.query.task,
    //   plan: route.query.plan
    // }),
    // component: Pay
  },
  // These pages can be load dynamically
  {
    path: '/honor-code',
    name: 'Honor',
    component: () => import('../views/Honor.vue')
  },
  {
    path: '/terms-of-service',
    name: 'Terms',
    component: () => import('../views/Terms.vue')
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: () => import('../views/Privacy.vue')
  },
  {
    path: '/cookie-policy',
    name: 'Cookie',
    component: () => import('../views/Cookie.vue')
  },
  {
    path: '/refund-policy',
    name: 'Refund',
    component: () => import('../views/Refund.vue')
  },
  {
    path: '/och-pay',
    name: 'Och Payment Form',
    component: () => import('../views/PaymentOch.vue')
  },
  {
    path: '/thank-you',
    name: 'Thank you',
    component: ThankYou
  },
  {
    path: '/thank-you-signup',
    name: 'Thank you',
    component: ThankYouPrivateTrustPilot
  },
  {
    path: '/private-trustpilot',
    name: 'Private Trustpilot',
    component: PrivateTrustpilot
  },
  {
    path: '/home-1',
    name: 'Home 1',
    component: () => import('../views/Home1.vue')
  },
  {
    path: '/home-2',
    name: 'Home 2',
    component: () => import('../views/Home2.vue')
  },
  {
    path: '/home-3',
    name: 'Home 3',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/for-students-1',
    name: 'Students 1',
    component: () => import('../views/Students1.vue')
  },
  {
    path: '/for-students-2',
    name: 'Students 2',
    component: () => import('../views/Students2.vue')
  },
  {
    path: '/for-students-3',
    name: 'Students 3',
    component: () => import('../views/Students3.vue')
  },
  {
    path: '/home-demo',
    name: 'Home Demo',
    component: () => import('../views/HomeDemo.vue')
  }
  // {
  //   path: '/success',
  //   name: 'Success',
  //   component: () => import('../views/Success.vue')
  // },
  // {
  //   path: '/fail',
  //   name: 'Fail',
  //   props: route => ({
  //     text: route.query.text
  //   }),
  //   component: () => import('../views/Fail.vue')
  // },
  // {
  //   path: '/payment-form',
  //   name: 'Payment Form',
  //   component: () => import('../views/PaymentForm.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  Vue.analytics.fbq.event('PageView')
  next()
})

export default router
